/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Constants of Money Transfer Component
 *
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @version 1.4.0
 * @since 1.2.0
 */

export const MONEY_TRANSFER_ACCOUNT_LIST_LENGTH = 10;

export enum EMoneyTransferSteps {
    Account = 'TransferAccountWizardStep',
    Final = 'TransferFinalWizardStep',
}

export enum EMoneyTransferStepsApiParams {
    amount = 'data.amount',
    from = 'data.from',
    to = 'data.to',
}

export const mapMoneyTransferStepsApiToParams: { [key in EMoneyTransferStepsApiParams]: string } = {
    [EMoneyTransferStepsApiParams.amount]: 'amount',
    [EMoneyTransferStepsApiParams.from]: 'accountFrom',
    [EMoneyTransferStepsApiParams.to]: 'accountTo',
};

export enum EMoneyTransferValidationCodes {
    ACCOUNT_FROM_BALANCE_NEGATIVE = 'account.from.balance.negative',
    ACCOUNT_NO_RECIPIENTS = 'account.from.no.recipients',
}

/*
* -------------------------------------------
*           ACTIONS
* -------------------------------------------
*/

export const MONEY_TRANSFER_SET_SEARCH_VALUE = '@@b2b_portal_ui/moneyTransfer/MONEY_TRANSFER_SET_SEARCH_VALUE';
export const MONEY_TRANSFER_CLEAR_SEARCH_VALUE = '@@b2b_portal_ui/moneyTransfer/MONEY_TRANSFER_CLEAR_SEARCH_VALUE';

export const MONEY_TRANSFER_SET_ACCOUNT = '@@b2b_portal_ui/moneyTransfer/MONEY_TRANSFER_SET_ACCOUNT';
export const MONEY_TRANSFER_SET_AMOUNT = '@@b2b_portal_ui/moneyTransfer/MONEY_TRANSFER_SET_AMOUNT';

export const MONEY_TRANSFER_SET_PARAMS = '@@b2b_portal_ui/moneyTransfer/MONEY_TRANSFER_SET_PARAMS';
export const MONEY_TRANSFER_SET_PARAMS_ERROR_CODE =
    '@@b2b_portal_ui/moneyTransfer/MONEY_TRANSFER_SET_PARAMS_ERROR_CODE';
export const MONEY_TRANSFER_HANDLE_NEXT = '@@b2b_portal_ui/moneyTransfer/HANDLE_NEXT';

export const MONEY_TRANSFER_LOAD_ACCOUNT_LIST = '@@b2b_portal_ui/moneyTransfer/MONEY_TRANSFER_LOAD_ACCOUNT_LIST';
export const MONEY_TRANSFER_LOAD_ACCOUNT_LIST_SUCCESSFUL =
    '@@b2b_portal_ui/moneyTransfer/MONEY_TRANSFER_LOAD_ACCOUNT_LIST_SUCCESSFUL';
export const MONEY_TRANSFER_LOAD_ACCOUNT_LIST_FAILED = '@@b2b_portal_ui/moneyTransfer/MONEY_TRANSFER_FAILED';

export const MONEY_TRANSFER_VALIDATE_START = '@@b2b_portal_ui/moneyTransfer/MONEY_TRANSFER_VALIDATE_START';
export const MONEY_TRANSFER_VALIDATE_SET_STATUS = '@@b2b_portal_ui/moneyTransfer/MONEY_TRANSFER_VALIDATE_SET_STATUS';

export const MONEY_TRANSFER_SET_CONFLICTS = '@@b2b_portal_ui/moneyTransfer/MONEY_TRANSFER_SET_CONFLICTS';

export const MONEY_TRANSFER_STORAGE_SAVE_STEP = '@@b2b_portal_ui/moneyTransfer/MONEY_TRANSFER_STORAGE_SAVE_STEP';

export const MONEY_TRANSFER_CHECK_RECIPIENTS_START =
    '@@b2b_portal_ui/moneyTransfer/MONEY_TRANSFER_CHECK_RECIPIENTS_START';
export const MONEY_TRANSFER_CHECK_RECIPIENTS_FINISH =
    '@@b2b_portal_ui/moneyTransfer/MONEY_TRANSFER_CHECK_RECIPIENTS_FINISH';
